/*! @pentacode/ui v0.1.0 */
import { formatCurrency as e, formatPercent as t } from "../format.js";
import { i as n, n as r, p as i, t as a } from "../../shared-D0HMDGlg.js";
import { i as o, n as s, r as c, t as l } from "../../polar-DKgYPero.js";
import { r as u } from "../../scene-Bdst6a-n.js";
import { t as d } from "../../mark-decorative-DmSkufit.js";
import { r as f, t as p } from "../../theme-BfnA-mmC.js";
import { savingsColors as m } from "./savings.js";
//#region src/charts/presets/return.ts
function h({ savings: e, fees: t }) {
	return t > 0 ? (e - t) / t : void 0;
}
function g({ savings: e, fees: t }) {
	return e >= t ? [{
		label: "Gebühren",
		value: t,
		color: m.Gebühren
	}, {
		label: "Netto-Ersparnis",
		value: e - t,
		color: p.positive
	}] : [{
		label: "Ersparnis",
		value: e,
		color: p.positive
	}, {
		label: "Ungedeckte Gebühren",
		value: t - e,
		color: p.negative
	}];
}
function _(p) {
	let m = g(p).filter((e) => e.value > 0), _ = m.reduce((e, t) => e + t.value, 0), v = h(p), y = (e, t, n, r) => c([{ id: e }], {
		angle: 0,
		radius: 0,
		text: () => e,
		key: "id",
		fill: "currentColor",
		dy: t,
		fontSize: n,
		fontWeight: r
	}), b = {
		inset: 8,
		radiusRatio: .9
	};
	return u({
		theme: f,
		marks: [l({
			...b,
			scales: {
				angle: null,
				radius: null
			},
			marks: [s(o(m, { value: "value" }), {
				innerRadius: ({ radius: e }) => e * .78,
				cornerRadius: 3,
				padAngle: () => .01,
				color: "label",
				key: "label"
			})]
		}), d(l({
			...b,
			scales: {
				angle: { scale: i().domain([0, 1]) },
				radius: { scale: i().domain([0, 1]) }
			},
			marks: [y(v === void 0 ? "–" : t(v), -6, 24, 700), y("Rendite", 16, 13, 400)]
		}))],
		scales: {
			x: null,
			y: null
		},
		color: n(m.map((e) => e.label), a(m), !1),
		tooltip: r(e, _)
	});
}
//#endregion
export { _ as returnChart, g as returnItems, h as savingsReturn };

//# sourceMappingURL=return.js.map